(function($){

/* from download-center.js */
function download_center_form_search () {
	var post_type = $('#post_type').val();
	var search_text = $('#s').val();

	download_center_ajax_form_send(search_text,post_type);
}

function download_center_ajax_form_send (search, post_type) {
	$.ajax({
		url: ajax.url,
		method:'POST',
		data: {
			action : 'search_download',
			post_type : post_type,
			search_text : search,
		},
		success: function(response) {
			$('.download-center-files-area').html(response.html);
		},

	});
}
/* from download-center.js */



/* from download-center.js */
if ( $('.download-center-form-area .searchbutton').length ){
	$('.download-center-form-area .searchbutton').on('click', function (e) {
		e.preventDefault();
		download_center_form_search();
	});
}

if ( $('.download-center-form-area #s').length ){
	$('.download-center-form-area #s').on('keyup', function (e) {
		if (e.key === 'Enter' || e.keyCode === 13) {
			download_center_form_search();
		}
	});
}
/* from download-center.js */

})(jQuery);